import React from 'react';
import Layout from "../components/App/Layout"
import SEO from "../components/App/SEO"
import NavbarStyleTwo from '../components/App/NavbarStyleTwo';
import PageBanner from '../components/Common/PageBanner';
import Footer from '../components/App/Footer';
import StartProjectWithUs from '../components/Common/StartProjectWithUs';
import { Link } from "gatsby"

import CXServicesImg1 from '../assets/images/marketing-ai/1.png'
import CXServicesImg2 from '../assets/images/marketing-ai/2.png'
import CXServicesImg3 from '../assets/images/marketing-ai/3.png'
import CXServicesImg4 from '../assets/images/marketing-ai/4.png'
import CXServicesImg5 from '../assets/images/marketing-ai/5.png'


const SingleServices = () => {
    return (
        <Layout>
            <SEO title="Marketing AI" description="Maximize your marketing efforts with the power of artificial intelligence.Incorporating artificial intelligence into your marketing efforts can help you take your promotions to the next level. AI can help you personalize your campaigns, optimize your targeting, and generate high-quality content, resulting in better results and higher conversions"/>

			<NavbarStyleTwo />

			<PageBanner 
                pageTitle="Marketing AI" 
            /> 

<div className="overview-area ptb-100">
                <div className="container">
                    <div className="overview-box">
                        <div className="overview-content">
                            <div className="content">
                                <span className="sub-title">Transform your marketing with AI</span>
                                <h2>Maximize your marketing efforts with the power of artificial intelligence.</h2>
                                <p>Incorporating artificial intelligence into your marketing efforts can help you take your promotions to the next level. AI can help you personalize your campaigns, optimize your targeting, and generate high-quality content, resulting in better results and higher conversions. Don't miss out on the opportunity to leverage AI in your marketing strategy.</p>
                                <div className="features-text">
                                    <h4>AI-driven marketing campaigns can lead to a 49% higher conversion rate than traditional marketing.</h4>
                                    <p></p>
                                </div>
               
                            </div>
                        </div>

                        <div className="overview-image">
                            <div className="image">
                                <img src={CXServicesImg1} alt="Cimplify Connected Customer Experience CX" />
                            </div>
                        </div>
                    </div>
                    <div className="services-area bg-f9f9f9 pt-100 pb-70">
                <div className="container">
                    <div className="section-title">
                        <span className="sub-title">AI-DRIVEN MARKETING FOR SUCCESS</span>
                        <h2>Core Solutions</h2>
                        {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p> */}
                    </div>

                    <div className="row d-flex justify-content-center text-center">
                        <div className="col-lg-4 col-md-6 col-sm-6" align = "center">
                        <Link to="/marketing-ai#content-creation-with-ai">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-bot"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Content Creation with AI</h3>
                                <p>Revolutionize your content creation with the power of artificial intelligence</p>
                            </div>
                            </Link>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6" align = "center">
                        <Link to="/marketing-ai#whatsapp-marketing">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-conversation"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Whatsapp Marketing</h3>
                                <p>Connect with your customers on a platform they already use with WhatsApp Marketing</p>
                            </div>
                        </Link>
                        </div>

                    </div>
                    <div className="row d-flex justify-content-center text-center">
                        <div className="col-lg-4 col-md-6 col-sm-6" align = "center">
                        <Link to="/marketing-ai#account-based-marketing">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-user-pin"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Account Based Marketing</h3>
                                <p>Focus on high-value accounts and deliver customized campaigns that speak directly to their needs and pain points.</p>
                            </div>
                        </Link>    
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6" align = "center">
                        <Link to="/marketing-ai#marketing-automation">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-shape-circle"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Marketing Automation</h3>
                                <p>Streamline your marketing efforts and drive success with the power of marketing automation.</p>
                            </div>
                        </Link>    
                        </div>

                    
                    </div>
                </div>
            </div>
                    <div id="content-creation-with-ai" className="overview-box">
                        <div className="overview-image">
                            <div className="image">
                                <img src={CXServicesImg2} alt="Cimplify Content Creation with AI" />
                            </div>
                        </div>
                        
                        <div className="overview-content">
                            <div className="content right-content">
                                <span className="sub-title">CREATE QUALITY CONTENT WITH AI</span>
                                <h2>Content Creation with AI</h2>
                                <p>Artificial intelligence (AI) powered content creation is revolutionizing the way businesses generate content. Whether you need blog articles, social media posts, or website content, AI can help you produce top-notch content that resonates with your audience. </p>
                                <ul className="features-list">
                                    <li><span><i className='bx bx-check'></i> Generate Blog Articles </span></li>
                                    <li><span><i className='bx bx-check'></i> Create Social Media Posts</span></li>
                                    <li><span><i className='bx bx-check'></i> Create Product Descriptions</span></li>
                                    <li><span><i className='bx bx-check'></i> Generate Website Content</span></li>
                                    <li><span><i className='bx bx-check'></i> Generate Email Subject Lines & Content</span></li>
                                    <li><span><i className='bx bx-check'></i> Create Video Scripts</span></li>
                                    <li><span><i className='bx bx-check'></i> Generate Voice overs</span></li>
                                    
                                </ul>
                            </div>
                        </div>
                    </div>
                     <div id="whatsapp-marketing" className="overview-box">
                       
                        
                        <div className="overview-content">
                            <div className="content right-content">
                                <span className="sub-title">MAXIMIZE YOUR REACH AND ENGAGEMENT</span>
                                <h2>Whatsapp Marketing</h2>
                                <p>WhatsApp is a convenient and effective way to reach your customers where they are, on their mobile devices. This means you can connect with them anytime, anywhere. Plus, the personal and meaningful communication provided via WhatsApp can help improve customer satisfaction and boost sales. </p>
                                <ul className="features-list">
                                    <li><span><i className='bx bx-check'></i> Personalized Promotional Campaigns</span></li>
                                    <li><span><i className='bx bx-check'></i> Easy Appointment / Ticket Booking</span></li>
                                    <li><span><i className='bx bx-check'></i> 24x7 Customer Support </span></li>
                                    <li><span><i className='bx bx-check'></i> Automated Lead Nurturing </span></li>
                                    <li><span><i className='bx bx-check'></i> Smart Bot Assitants</span></li>
                                    <li><span><i className='bx bx-check'></i> Whatsapp Shopping</span></li>
                                </ul>
                            </div>
                        </div>

                        <div className="overview-image">
                            <div className="image">
                                <img src={CXServicesImg3} alt="Cimplify Whatsapp Marketing" />
                            </div>
                        </div>
                    </div>
                    <div id="account-based-marketing" className="overview-box">
                        <div className="overview-image">
                            <div className="image">
                                <img src={CXServicesImg4} alt="Cimplify Account Based Marketing" />
                            </div>
                        </div>
                        
                        <div className="overview-content">
                            <div className="content right-content">
                                <span className="sub-title">PERSONALIZED MESSAGING. PRECISE TARGETING.</span>
                                <h2>Account Based Marketing</h2>
                                <p>Account-based marketing is a targeted and personalized approach to marketing that focuses on high-value accounts. With AI-Powered ABM, you can personalize your marketing efforts to each individual account, increasing the chances of conversions and building long-lasting, mutually beneficial relationships.  </p>
                                <ul className="features-list">
                                    <li><span><i className='bx bx-check'></i> Account-specific Lead Generation</span></li>
                                    <li><span><i className='bx bx-check'></i> Customized Content & Collateral </span></li>
                                    <li><span><i className='bx bx-check'></i> Targeted Ad Campaigns </span></li>
                                    <li><span><i className='bx bx-check'></i> Personalized Drip Campaigns</span></li>
                                    <li><span><i className='bx bx-check'></i> Omnichannel Engagement for Key Accounts</span></li>
                                    
                                </ul>
                            </div>
                        </div>
                    </div>
                     <div id="marketing-automation" className="overview-box">
                       
                        
                        <div className="overview-content">
                            <div className="content right-content">
                                <span className="sub-title">EFFORTLESS. EFFECIENT. TARGETED.</span>
                                <h2>Marketing Automation</h2>
                                <p>Marketing automation helps businesses streamline their marketing efforts and drive success. By automating repetitive tasks, such as email campaigns and social media posts, marketing automation allows businesses to focus on strategy and creativity. </p>
                                <ul className="features-list">
                                    <li><span><i className='bx bx-check'></i> Conversion Rate Optimization</span></li>
                                    <li><span><i className='bx bx-check'></i> Customer Segmentation & Personalization</span></li>
                                    <li><span><i className='bx bx-check'></i> Automated Drip Campaigns </span></li>
                                    <li><span><i className='bx bx-check'></i> Social Media Automation</span></li>
                                    <li><span><i className='bx bx-check'></i> Customer Lifecycle Engagement</span></li>
                                    <li><span><i className='bx bx-check'></i> Analyzing and Optimizing Marketing Campaign</span></li>
 
                                </ul>
                            </div>
                        </div>

                        <div className="overview-image">
                            <div className="image">
                                <img src={CXServicesImg5} alt="Cimplify Marketing Automation" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

          



            

            <StartProjectWithUs />
			  
			<Footer />
		</Layout>
    )
}

export default SingleServices;